// src/features/wallet/components/WalletTransactionsCard.tsx
import { Card, formatPersianNumber, formatSolarDate } from '../../../app/components/foundation';
import type { WalletTransaction } from '../types/wallet.types';

export interface WalletTransactionsCardProps {
  transactions: WalletTransaction[];
}

const TRANSACTION_TYPE_LABEL: Record<WalletTransaction['type'], string> = {
  topup: 'شارژ کیف پول',
  withdraw: 'برداشت از کیف پول',
};

/**
 * Workspace card: this wallet's recent transactions.
 * Uses only the real WalletTransaction contract:
 * id, type, amount, date.
 */
export function WalletTransactionsCard({ transactions }: WalletTransactionsCardProps) {
  return (
    <Card className="vania-wallet-workspace-card">
      <h2 className="vania-wallet-workspace-card-title">تراکنش‌های اخیر</h2>

      {transactions.length === 0 ? (
        <p className="vania-wallet-workspace-empty">تراکنشی برای این کیف پول ثبت نشده است.</p>
      ) : (
        <ul className="vania-wallet-workspace-list">
          {transactions.map((transaction) => (
            <li key={transaction.id} className="vania-wallet-workspace-list-item">
              <span className="vania-wallet-workspace-list-type">
                {TRANSACTION_TYPE_LABEL[transaction.type]}
              </span>

              <span
                className={`vania-wallet-workspace-list-primary vania-wallet-workspace-amount-${transaction.type}`}
                dir="ltr"
              >
                {formatPersianNumber(transaction.amount)}
              </span>

              <span className="vania-wallet-workspace-list-secondary" dir="ltr">
                {formatSolarDate(transaction.created_at || '-')}
              </span>
              <span className="vania-wallet-workspace-list-secondary">
                وضعیت: {transaction.status || '-'}
              </span>
            </li>
          ))}
        </ul>
      )}
    </Card>
  );
}
